function findParent(element, func) {
  if (!element) {
    return null;
  }

  if (func(element)) {
    return element;
  } else {
    return findParent(element.parentElement, func);
  }
}
export default function initDataSubmit() {
  document.querySelectorAll("[data-submit]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      const form = findParent(
        event.target,
        (elem) => elem.tagName.toLowerCase() === "form"
      );
      form && form.submit();
      event.preventDefault();
    });
  });
}
